<template>
  <div class='myCollapse'>
    <div class='heard'>{{title.title}}</div>
    <van-collapse v-model='activeNames'>
      <van-collapse-item  name='1'>
        <slot slot='title' name='title' v-if="card.Content1">
          <div class='money'>
            <span v-if="money"><i class="iconfont money-size">{{'\ue60a'}}</i><span class="money-font">{{setMonths(card.Content1)}}</span></span>
            <span v-else>{{card.Content1}}</span>
            <span>{{card.Content2}}</span>
          </div>
        </slot>
        <div class='content'>
          <div class="first">
            <div class='top'>{{title.title2}}</div>
            <div class='bottom'>{{card.Content3}}</div>
          </div>
           <div class="centent-auto">
            <div class='top center'>{{title.title3}}</div>
            <div class='bottom center'>{{card.Content4}}</div>
          </div>
          <div class="end" v-if="title.title4">
            <div class='top right'>{{title.title4}}</div>
            <div class='bottom right'>{{card.Content5}}</div>
          </div>
        </div>
        <div class='content content-bottom' v-if="title.title5">
          <div>
            <div class='top'>{{title.title5}}</div>
            <div class='bottom'>{{card.Content6}}</div>
          </div>
           <div class="end">
            <div class='top center'>{{title.title6}}</div>
            <div class='bottom center content7'>{{card.Content7}}</div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import { Collapse, CollapseItem } from 'vant'
export default {
  data () {
    return {
      activeNames: ['']
    }
  },
  props: {
    card: {
      type: Object,
      default: () => {}
    },
    title: {
      type: Object,
      default: () => {}
    },
    money: {
    }
  },
  computed: {
    setMonths () {
      return function (money) {
        return parseInt(money) === money ? money + '.00' : money
      }
    }
  },
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  }
}
</script>
<style lang='less' src='./style.less' scoped></style>
